import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { filenameFromDisposition } from "../lib/performance";
import { downloadCsv } from "../lib/report-csv";

/**
 * GET …/performance/export (spec §4.4) → browser download. The BE names the
 * file; when the browser can't read Content-Disposition (CORS without
 * Access-Control-Expose-Headers), the caller's client-built name is used.
 * Errors surface through the global mutation-error toast.
 */
export function usePerformanceExport(id: string) {
  return useMutation({
    mutationFn: async (fallbackFilename: string): Promise<string> => {
      const { data, response } = await apiClient.GET("/v1/promotions/{id}/performance/export", {
        params: { path: { id } },
        parseAs: "text",
      });
      const filename =
        filenameFromDisposition(response.headers.get("content-disposition")) ?? fallbackFilename;
      downloadCsv(filename, data ?? "");
      return filename;
    },
  });
}
